export default __webpack_public_path__ + "static/media/habanoBG.a442428e.jpg";